const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const SID_KEY = 'nbl_sid';

export const getSessionId = () => {
  let sid = localStorage.getItem(SID_KEY);
  if (!sid) {
    sid = crypto.randomUUID();
    localStorage.setItem(SID_KEY, sid);
  }
  return sid;
};

const post = (path, body) => {
  try {
    fetch(`${API}${path}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
      keepalive: true,
    }).catch(() => {});
  } catch (e) { /* tracking must never break the site */ }
};

let started = false;
export const initTracking = (path) => {
  if (started) return;
  started = true;
  post('/track/session', {
    session_id: getSessionId(),
    entry_page: path,
    path,
    referrer: document.referrer || '',
    user_agent: navigator.userAgent,
  });
  post('/track/pageview', { session_id: getSessionId(), path });
  setInterval(() => {
    if (document.visibilityState === 'visible') {
      post('/track/beat', { session_id: getSessionId(), path: window.location.pathname });
    }
  }, 20000);
};

export const trackPageView = (path) => {
  if (!started) return initTracking(path);
  post('/track/pageview', { session_id: getSessionId(), path });
};

export const trackEvent = (type, meta = '') => {
  post('/track/event', { session_id: getSessionId(), type, path: window.location.pathname, meta });
};

export const setupClickTracking = () => {
  document.addEventListener('click', (e) => {
    const el = e.target.closest('a, button');
    if (!el) return;
    const href = el.getAttribute('href') || '';
    if (href.includes('/get-a-quote')) trackEvent('cta_click', 'quote');
    else if (href.startsWith('tel:')) trackEvent('cta_click', 'call');
  });
};
